import dayjs from 'dayjs';
import React from 'react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import LoadingOpacitySmallBox from '@/UI/LoadingOpacitySmallBox';

type Props = {
  values: {
    company: {
      Name: string;
      ID: number;
    } | null;
    startDate: string | null;
    endDate: string | null;
  };
  loading: boolean;
};

// ✅ Ensure ref is properly forwarded
const OpenSearchBtn = React.forwardRef<HTMLButtonElement, Props>(
  ({ loading, values, ...props }, ref) => {
    return (
      <Button
        disabled={loading}
        ref={ref} // ✅ Attach ref to the Button
        className="relative my-2 flex h-16 flex-col gap-5"
        variant="outline"
        {...props} // ✅ Spread props to ensure PopoverTrigger events work
      >
        <div className="w-full">
          <h3 className="mb-1">{values.company?.Name || 'اختيار الشركة'}</h3>
          <div className="flex justify-between gap-4">
            <Badge
              className="flex rounded-sm"
              color={values.startDate ? 'success' : 'warning'}
            >
              {values?.startDate
                ? dayjs(values.startDate).format('DD, MMMM, YYYY')
                : 'تاريخ البداية'}
            </Badge>
            <Badge
              className="flex justify-between gap-20 rounded-sm"
              color={values.endDate ? 'success' : 'warning'}
            >
              {values?.endDate
                ? dayjs(values.endDate).format('DD, MMMM, YYYY')
                : 'تاريخ النهاية'}
            </Badge>
          </div>
        </div>
        {loading && <LoadingOpacitySmallBox />}
      </Button>
    );
  },
);

OpenSearchBtn.displayName = 'OpenSearchBtn';

export default OpenSearchBtn;
